import { Alert, Button, ButtonGroup, Card, Col, Dropdown, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap"
import CustomTable from "../../CustomTable"
import { useDispatch, useSelector } from "react-redux";
import { getNotificationHistory } from "../../../redux/moduloNotificaciones/NotificationHistory/actions";
import CustomPagint from "../../CustomPagint";
import { useState } from "react";

const HistoryModal = ({ showModal, setShowModal, correo_id }) => {
    const dispatch = useDispatch();
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [filter, setFilter] = useState("");

    const filters = [
        { id: "descripcion", desc: "Descripción" },
        { id: "creado_por_username", desc: "Usuario" },
        { id: "fecha_creacion", desc: "Fecha de creación" },
    ];

    const [tipoBusqueda, setTipoBusqueda] = useState({ id: "descripcion", desc: "Descripción" });


    const {
        loading,
        saveLoading,
        notificationHistoriesLength,
        notificationHistories,
        notificationHistoryError,
        formError,
    } = useSelector((state) => state.notificationHistory);

    const pages = Math.ceil(notificationHistoriesLength / limit);

    const getIconAndColor = (value) => {
        switch (value) {
            case "creacion":
                return { icon: "add_alert", color: "text-primary", tooltip: "Creación" };
            case "error":
                return { icon: "error", color: "text-danger", tooltip: "Error" };
            case "cambio_estado":
                return { icon: "edit_notifications", color: "text-warning", tooltip: "Cambio de estado" };
            case "envio":
                return { icon: "mark_email_read", color: "text-success", tooltip: "Envío" };
            default:
                return { icon: "help", color: "text-secondary", tooltip: "Ayuda" };
        }

    }

    const columns = [
        {
            Header: "Realizado por",
            accessor: "creado_por_username",
            Filter: "",
            Cell: (value) => (
                <span>
                    {value.row.original.creado_por_username
                        ? value.row.original.creado_por_username
                        : "-"}
                </span>
            )
        },
        {
            Header: "Fecha",
            accessor: "fecha_creacion",
            Filter: "",
            Cell: (value) => (
                <span>
                    {value.row.original.fecha_creacion
                        ? new Date(value.row.original.fecha_creacion).toLocaleString()
                        : "No disponible"}
                </span>
            )
        },
        {
            Header: "Descripción",
            accessor: "descripcion",
            Filter: ""
        },
        {
            Header: "Tipo de Acción",
            accessor: "tipo_accion",
            Filter: "",
            Cell: (value) => {
                const { icon, color, tooltip } = getIconAndColor(value.row.original.tipo_accion);
                return (
                    <OverlayTrigger
                        placement="bottom"
                        container={document.querySelector('.modal')}
                        overlay={<Tooltip id="button-tooltip-2">{tooltip}</Tooltip>}
                    >
                        <span className={`${color}`}>
                            <i className="material-icons">{icon}</i>
                        </span>
                    </OverlayTrigger>
                );
            }
        },

    ];

    const getNotifications = (off = offset, lim = limit, filt = filter) =>
        dispatch(
            getNotificationHistory({
                offset: off,
                limit: lim,
                tipo_busqueda1: "correo_id",
                filter1: correo_id,
                tipo_busqueda2: tipoBusqueda.id,
                filter2:
                    tipoBusqueda.id === "fecha_creacion"
                        ? filt !== ""
                            ? !isNaN(filt)
                                ? filt
                                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                                    8
                                )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                                    4
                                )}-${filt.charAt(0)}${filt.charAt(1)}`
                            : filt
                        : filt,
            })
        );

    const onSearch = (e) => {
        e.preventDefault();
        setFilter(e.target.filter.value);
        const oOffset = 0;
        setOffset(0);
        setCurrentPage(1);
        getNotifications(oOffset, limit, e.target.filter.value);
    };



    const seeAll = () => {
        const oSearch = "";
        setFilter(oSearch);
        const oOffset = 0;
        setOffset(oOffset);
        setCurrentPage(1);
        getNotifications(oOffset, limit, oSearch);
    };

    return (
        <Modal
            show={showModal}
            size="lg"
            onHide={() => {
                setShowModal(false);
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                    Historial de Envío
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert show={notificationHistoryError || formError} variant="danger">
                    {notificationHistoryError || formError}
                </Alert>
                {
                    loading ? (
                        <div className="d-flex justify-content-center">
                            <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                            />
                        </div>
                    ) : (
                        <>
                            <Form onSubmit={onSearch}>
                                <Row className="justify-content-sm-end align-items-center flex-nowrap">
                                    <Col>
                                        <h6>
                                            <b>Busqueda por: {tipoBusqueda.desc}</b>
                                        </h6>
                                    </Col>
                                    <Col xs="auto">
                                        <Form.Control
                                            name="filter"
                                            id="filter"
                                            placeholder="Buscar"
                                            className="rounded-pill form-control-sm"
                                            type="search"
                                        ></Form.Control>
                                    </Col>
                                    <Col xs="auto">
                                        <ButtonGroup>
                                            <Button
                                                onClick={() => seeAll()}
                                                variant="light"
                                                size="sm"
                                                className="rounded-circle mr-1"
                                            >
                                                <i className="material-icons">list</i>
                                            </Button>

                                            <OverlayTrigger
                                                placement="auto"
                                                overlay={
                                                    <Tooltip>Seleccionar Filtrado</Tooltip>
                                                }
                                            >
                                                <Dropdown className="ml-3 mr-3">
                                                    <Dropdown.Toggle
                                                        variant="light"
                                                        className="btn-sm font rounded-pill"
                                                    >
                                                        <i className="material-icons">filter_list</i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {filters.map((item) => (
                                                            <Dropdown.Item
                                                                onClick={() => setTipoBusqueda(item)}
                                                                key={item.id}
                                                            >
                                                                {item.desc}
                                                            </Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </OverlayTrigger>
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                            </Form>
                            {(!notificationHistoryError && !formError && notificationHistoriesLength > 0) ? (
                                <>
                                    <Card className="border-0">
                                        <Card.Body className="px-1 px-sm-2">
                                            <CustomTable columns={columns} data={notificationHistories} />
                                        </Card.Body>
                                    </Card>
                                    <CustomPagint
                                        limit={limit}
                                        setLimit={setLimit}
                                        offset={offset}
                                        setOffset={setOffset}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        dataLenght={notificationHistoriesLength}
                                        pages={pages}
                                        pagFunc={getNotifications}
                                    />
                                </>
                            ) : (
                                <Alert show={!notificationHistoriesLength} variant="info" className="my-4">
                                    No hay historiales para esta notificación.
                                </Alert>
                            )}

                        </>
                    )
                }
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowModal(false)}
                    disabled={loading || saveLoading}
                >
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default HistoryModal;